<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <span>{{reportType?.name}}</span>
    </div>
  </kendo-dialog-titlebar>
  <section class="section-content">
    <kendo-gridlayout class="mt-16" [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }"
      [cols]="['repeat(1,minmax(0,1fr))']">
      <kendo-gridlayout-item *ngFor="let item of checkboxes; let i = index">
        <div class="kendo-formfield">
          <div class="k-checkbox-wrap">
            <input type="checkbox" kendoCheckBox [(ngModel)]="item.checked" (change)="onSelect()" [id]="'chk' + i" />
            <kendo-label [for]="'chk' + i" class="k-checkbox-label font-weight-600 checkbox-margin cursor-pointer"
              style="margin-bottom: 0" [text]="item?.text">
            </kendo-label>
          </div>
        </div>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <div class="kendo-formfield">
          <div class="k-checkbox-wrap">
            <input type="checkbox" kendoCheckBox [(ngModel)]="none" (change)="onChangeNone()" [id]="'chk-none'" />
            <kendo-label [for]="'chk-none'" class="k-checkbox-label font-weight-600 checkbox-margin cursor-pointer"
              style="margin-bottom: 0" [text]="'None'">
            </kendo-label>
          </div>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </section>
  <kendo-dialog-actions layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-8" (click)="close()">
      Cancel
    </button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" [disabled]="!isChecked"
      (click)="createReport()">
      Create report
    </button>
  </kendo-dialog-actions>
</div>
